<template>
  <div class="seven-continents-tabs">
    <div
      class="seven-continents-tabs--item"
      :class="{'is-active': item.value === currentValue }"
      v-for="(item,index) in list"
      :key="index"
      @click="clickItem(item,index)"
    >
      {{item.label||"-"}}({{item.total||0}})
    </div>
  </div>
</template>

<script>
let defaultList = [
  {label:"全部",value:"all",total:0,},
  {label:"北美洲",value:"bmz",total:0,},
  {label:"大洋洲",value:"dyz",total:0,},
  {label:"亚洲",value:"yz",total:0,},
  {label:"非洲",value:"fz",total:0,},
  {label:"欧洲",value:"oz",total:0,},
  {label:"南美洲",value:"nmz",total:0,},
  {label:"南极洲",value:"njz",total:0,},
];
export default {
  name: "sevenContinentsTabs",
  props:{
    list:{
      type:Array,
      default:()=> defaultList,
    },
    defaultSelect:{
      type:[String,Number],
      default:"all",
    },
  },
  data(){
    return {
      currentValue:"",
    }
  },
  watch:{
    defaultSelect:{
      immediate:true,
      handler(val){
        this.currentValue = val;
      }
    }
  },
  methods:{
    clickItem(item,index){
      this.currentValue = item.value;
      this.$emit("update:defaultSelect",item.value);
      this.$emit("change",item.value,item);
    },
  },
}
</script>

<style scoped lang="scss">
.seven-continents-tabs{
  padding-top: 20px;
  height: 40px;
  // background-color: #F6F6F6;
  border-radius: 20px;
  display: flex;
  &--item{
    width: 100px;
    margin-right: 20px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    text-align: center;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #666666;
    background: #DEDEDE;
    cursor: pointer;
    user-select: none;
    &.is-active{
      background: #FFD7C6;
      color: #FF4D01;
      cursor: default;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotCountry/sevenContinentsTabs.vue